module.exports = __webpack_public_path__ + "dist/media/ec_comp_radio.295d00b2.svg";